import React from 'react';
import algoliaCubesLogo from '@/assets/algolia-logo.jpg';
import pricingSaaSLogo from '@/assets/pricingsaas-logo.png';

interface AssetFooterProps {
  companyName: string;
  viewMode: string;
  aspectRatio: string;
  companyLogo?: string;
}

export const AssetFooter: React.FC<AssetFooterProps> = ({
  companyName,
  viewMode,
  aspectRatio,
  companyLogo
}) => {
  return (
    <div className="flex items-center justify-between px-6 h-[75px] rounded-b-lg" style={{ backgroundColor: 'var(--vae-card, #111827)' }}>
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center overflow-hidden">
          {companyLogo ? (
            <img
              src={companyLogo}
              alt={`${companyName} logo`}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-blue-600 flex items-center justify-center">
              <span className="text-white text-xs font-bold">
                {companyName.charAt(0).toUpperCase()}
              </span>
            </div>
          )}
        </div>
        <span className="font-semibold text-white text-base">{companyName}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-gray-400 text-sm">Curated by</span>
        <img 
          src={pricingSaaSLogo} 
          alt="PricingSaaS" 
          className="h-6 object-contain"
        />
      </div>
    </div>
  );
};